import type { ReactNode } from 'react';
import styles from './Motion.module.css';

/** Inline text with a highlight sweeping across it: the chat's one signal that
 *  something is still in progress. */
export function LiveText({ children }: Readonly<{ children: ReactNode }>) {
  return <span className={styles.shimmer}>{children}</span>;
}
